﻿export const upOrDownOnScrollWheel = (elm: HTMLElement) => {
    let lastScrollPos = 0;
    const navLists = document.querySelectorAll(".main-site-header .hasChildren");
    const navIcons = document.querySelectorAll(".main-site-header .icon");
    const scrollThreshold = 100;
    const scrollDelta = 5;

    window.addEventListener("scroll", function () {
        const currentScroll = Math.max(0, window.scrollY);
        const scrollDifference = Math.abs(currentScroll - lastScrollPos);

        // Ignore tiny scroll movements to prevent flickering
        if (scrollDifference < scrollDelta) {
            return;
        }

        // At the top of the page, remove all scroll classes
        if (currentScroll <= scrollThreshold) {
            elm.classList.remove("scroll-up");
            elm.classList.remove("scroll-down");
            lastScrollPos = currentScroll;
            return;
        }

        if (currentScroll > lastScrollPos) {
            elm.classList.add("scroll-down");
            elm.classList.remove("scroll-up");
            navLists.forEach((navList) => navList.classList.remove("open"));
            navIcons.forEach((navIcon) => navIcon.classList.remove("active"));
        } else {
            elm.classList.add("scroll-up");
            elm.classList.remove("scroll-down");
        }

        lastScrollPos = currentScroll;
    });
};

export const closeBackDrop = (fn?: Function) => {
    const backgdrop = document.querySelector<HTMLElement>(".general-modal-bg");

    if (!backgdrop) return;

    if (!backgdrop || !fn) return;

    backgdrop.addEventListener("click", (event) => {
        if (fn) {
            fn();
        }
        
        backgdrop.classList.add("general-modal-bg--hidden");
    });

    window.addEventListener("keydown", (event: KeyboardEvent) => {
        if (
            event.key === "Escape" &&
            !backgdrop.classList.contains("general-modal-bg--hidden")
        ) {
            if (fn) {
                fn();
            }

            backgdrop.classList.add("general-modal-bg--hidden");
        }
    });
};

export const isElementOutOfViewport = (el) => {
    const rect = el.getBoundingClientRect();
    const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
    const windowWidth =
        window.innerWidth || document.documentElement.clientWidth;

    return (
        rect.bottom < 0 ||
        rect.right < 0 ||
        rect.left > windowWidth ||
        rect.top > windowHeight
    );
};

export function pipe(...functions) {
    return function (value) {
        return functions.reduce((currentyValue, currentFunction) => {
            return currentFunction(currentyValue);
        }, value);
    };
}

export const debounce = (func: Function, wait: number = 250) => {
    let timeout: ReturnType<typeof setTimeout>;

    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func();
        }, wait);
    };
};
